import React from 'react';
import { Navigation } from 'lucide-react';
import '../styles/LocationCard.css';

const LocationCard = ({ icon, venue, location, time, mapsUrl, bgImage }) => {
  const handleDirections = () => {
    window.open(mapsUrl, '_blank');
  };

  return (
    <div className="location-card">
      <div className="location-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="location-overlay"></div>
      </div>
      <div className="location-content">
        <div className="location-icon">{icon}</div>
        <h3 className="location-venue">{venue}</h3>
        <p className="location-place">{location}</p>
        <p className="location-time">{time}</p>
        <button className="directions-button" onClick={handleDirections}>
          <Navigation className="button-icon" />
          Get Directions
        </button>
      </div>
    </div>
  );
};

export default LocationCard;